var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar'),_vm._m(0),_c('tlfooter')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"role":"main"}},[_c('div',{staticClass:"jumbotron"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"display-3"},[_vm._v("404 - not found")]),_c('p',[_vm._v("Whoooops! The page you requested was not found. Might be a typo?")])])])])
}]

export { render, staticRenderFns }